import { Controller } from "@hotwired/stimulus"
// Import only the Tooltip plugin, NOT the full `bootstrap` bundle. The full
// bundle registers BS4's data-api click handlers (collapse/modal/dropdown) as
// an import side effect, and since this controller is globbed into the legacy
// entrypoint it loads on BS2.3 pages too — where BS4's collapse handler then
// fights BS2.3's own collapse (e.g. the book reader nav opens then snaps shut).
// The standalone plugin file has no data-api side effect.
import Tooltip from "bootstrap/js/dist/tooltip"

export default class extends Controller {
  connect() {
    this.tooltip = new Tooltip(this.element)
  }

  disconnect() {
    this.tooltip.dispose()
  }
}
